import axiosInstance from '../api';
import { notification } from 'antd';

export const getAllSavedItinerary = async ({
    skip = 0,
    limit = 10,
    user_ids = [],
    category_ids = [],
    filter_start_date = null,
    filter_end_date = null,
    created_updated_start_date = null,
    created_updated_end_date = null,
    search = null,
  } = {}) => {
    try {
      const params = new URLSearchParams();
      params.append("skip", skip);
      params.append("limit", limit);

      if(filter_start_date && filter_end_date){
        params.append("filter_start_date", filter_start_date);
        params.append("filter_end_date", filter_end_date);
      }

      // one range, matched against created_at OR updated_at
      if(created_updated_start_date && created_updated_end_date){
        params.append("created_updated_start_date", created_updated_start_date);
        params.append("created_updated_end_date", created_updated_end_date);
      }

      if (user_ids?.length) params.append("user_ids", user_ids.join(","));
      if (category_ids?.length) params.append("category_ids", category_ids.join(","));
      // Matches against the itinerary's own headline/from_location/to_location -
      // not the owning user's identity (that's a separate user search).
      if (search) params.append("search", search);

      const response = await axiosInstance.get(`/get_all_saved_itinerary?${params.toString()}`);
      if(response?.data?.status_code === 200){
        return response?.data?.data;
      }
      notification.error({
        message: "Error Fetching Data",
        description: response?.data?.message || "Failed to fetch data.",
        duration: 3,
      });
      
    } catch (error) {
      console.log("error -->", error)
      notification.error({
        message: "Error Fetching data",
        description: error.response?.data?.message || "Failed to fetch data.",
        duration: 3,
      });
      throw new Error("Error fetching list");
    }
};

// Get users
export const fetchUsers = async (page, name) => {
    try {
      const params = {
        skip: page * 10,
        limit: 10,
        name: name || "",
      };
  
      const response = await axiosInstance.get("/users/get_user_for_select", { params });
  
      if (response?.data?.status_code === 200) {
        return response?.data?.data?.users.map((item) => ({
          label: item.name,
          value: item.id,
          email: item.email,
        }));
      }
  
      notification.error({
        message: "Error Fetching users",
        description: response?.data?.message || "Failed to fetch users list.",
        duration: 3,
      });
  
      return [];
    } catch (error) {
      console.error("Error fetching users", error);
      throw new Error("Error fetching users");
    }
};

export const fetchUserForSearch = async (page, name, type=null, search_list=null) =>{
  try {
    const body = {
      skip: page * 10,
      limit: 10,
      name: name || "",
      type: type,
      search_list:search_list
    };

    // POST (not GET+params): search_list can carry hundreds of emails
    // (mass notification copy-paste flow) which as a query string exceeds
    // proxy/webserver URL length limits in prod.
    const response = await axiosInstance.post("/users/get_user_for_select", body);

    if (type === 'copy_paste'){
      return {
        "avl_user": response?.data?.data?.available_users.map((item) => ({
          // label: "#"+item.id + " " + item.name +"("+item.email+")",
          label: item.name,
          value: item.id,
          email: item.email,
        })),
        "not_avail": response?.data?.data.not_available
      };
    }

    if (response?.data?.status_code === 200) {
      return response?.data?.data?.users.map((item) => ({
        label: item.name,
        value: item.id,
        email: item.email,
      }));
    }

    notification.error({
      message: "Error Fetching users",
      description: response?.data?.message || "Failed to fetch users list.",
      duration: 3,
    });

    return [];
  } catch (error) {
    console.error("Error fetching users", error);
    throw new Error("Error fetching users");
  }
}

// Get users
export const fetchCategory = async (page, name) => {
  try {
    const params = {
      skip: page * 10,
      limit: 10,
      search: name || "",
    };

    const response = await axiosInstance.get("/get_question_category", { params });

    if (response?.data?.status_code === 200) {
      return response?.data?.data?.data?.map((item) => ({
        label: item.category_name,
        value: item.id,
      }));
    }

    notification.error({
      message: "Error Fetching users",
      description: response?.data?.message || "Failed to fetch users list.",
      duration: 3,
    });

    return [];
  } catch (error) {
    console.error("Error fetching users", error);
    throw new Error("Error fetching users");
  }
};


export const getUserItineraryDetails = async ({
  itineary_id = 0,
  user_id = 0,
  type = "view",
} = {}) => {
  try {
    const response = await axiosInstance.post(`/get_user_itinerary_details_all`, {
      itineary_id,
      user_id,
      type,
    });

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }

    notification.error({
      message: "Error Fetching Data",
      description: response?.data?.message || "Failed to fetch data.",
      duration: 3,
    });

  } catch (error) {
    console.log("error -->", error);
    notification.error({
      message: "Error Fetching Data",
      description: error.response?.data?.message || "Failed to fetch data.",
      duration: 3,
    });
    throw new Error("Error fetching list");
  }
};

export const fetchItineraries = async (page = 0, name = "", id = null) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", page * 10);
    params.append("limit", 10);
    if (name) params.append("name", name);
    if (id) params.append("id", id);

    const response = await axiosInstance.get(`/admin_itinerary?${params.toString()}`);

    if (response?.data?.status_code === 200) {
      return response.data.data.itinerary.map((item) => ({
        label: item.itineary_headline_text,
        value: item.id,
        category_name: item.category_name,
      }));
    }

    notification.error({
      message: "Error Fetching Itinerary",
      description: response?.data?.message || "Failed to fetch Itinerary list.",
      duration: 3,
    });

    return [];
  } catch (error) {
    console.error("Error fetching Itineraries", error);
    throw new Error("Error fetching Itineraries");
  }
};


export const downloadUserItineary = async ({
  user_ids = [],
  category_ids = [],
  filter_start_date = null,
  filter_end_date = null,
  created_updated_start_date = null,
  created_updated_end_date = null,
} = {}) => {
  try {
    const params = new URLSearchParams();

    if(filter_start_date && filter_end_date){
      params.append("filter_start_date", filter_start_date);
      params.append("filter_end_date", filter_end_date);
    }

    // one range, matched against created_at OR updated_at
    if(created_updated_start_date && created_updated_end_date){
      params.append("created_updated_start_date", created_updated_start_date);
      params.append("created_updated_end_date", created_updated_end_date);
    }

    if (user_ids?.length) params.append("user_ids", user_ids.join(","));
    if (category_ids?.length) params.append("category_ids", category_ids.join(","));

    const response = await axiosInstance.get(`/export_all_saved_itinerary?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // extract filename from Content-Disposition header
      console.log(response.headers)
      const disposition = response.headers["content-disposition"];
      let filename = "user_itineary_report.xlsx"; // fallback
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); // remove quotes if present
      }
      a.download = filename; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      return response; 
    } else {
      throw new Error("Download failed"); 
    }
    
  } catch (error) {
    console.log("error -->", error)
    notification.error({
      message: "Error Download data",
      description: error.response?.data?.message || "Failed to download data.",
      duration: 3,
    });
    throw new Error("Error fetching download data");
  }
}
// Same endpoint as fetchUserForSearch, but opts in to the platform snapshot via
// with_platform=true so the coupon picker can show an Apple/Android icon per
// user. Kept as a SEPARATE function because several pages depend on the exact
// option shape fetchUserForSearch returns - adding `platform` there would leak
// into all of them.
export const fetchUserForSearchWithPlatform = async (page, name, type = null, search_list = null) => {
  try {
    const body = {
      skip: page * 10,
      limit: 10,
      name: name || "",
      type: type,
      search_list: search_list,
      with_platform: true,
    };

    const response = await axiosInstance.post("/users/get_user_for_select", body);

    if (type === 'copy_paste') {
      return {
        "avl_user": response?.data?.data?.available_users.map((item) => ({
          label: item.name,
          value: item.id,
          email: item.email,
          platform: item.platform,
        })),
        "not_avail": response?.data?.data.not_available
      };
    }

    if (response?.data?.status_code === 200) {
      return response?.data?.data?.users.map((item) => ({
        label: item.name,
        value: item.id,
        email: item.email,
        platform: item.platform,
      }));
    }

    notification.error({
      message: "Error Fetching users",
      description: response?.data?.message || "Failed to fetch users list.",
      duration: 3,
    });

    return [];
  } catch (error) {
    console.error("Error fetching users", error);
    throw new Error("Error fetching users");
  }
};
